import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { getSnackbarSelector } from '@store/snackbars/snackbars.selectors';
import { SnackbarsService } from '@services';
import { Snackbars } from '@enums';
import { Icon } from '@elements';
import { SnackbarAlert, StyledSnackbar } from './snackbar.styles';
import ErrorIcon from '@images/ep-alert.svg';
import InfoIcon from '@images/ep-info.svg';
import SuccessIcon from '@images/ep-success.svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var SnackbarComponent = function SnackbarComponent(_ref) {
  var _snackBar$data, _snackBar$data2, _snackBar$data3, _snackBar$data4;

  var snackbarId = _ref.snackbarId;
  var snackBar = useSelector(getSnackbarSelector(snackbarId));
  var rejectSnackbar = useCallback(function () {
    SnackbarsService.close(snackbarId);
  }, [snackbarId]);
  var handleClose = useCallback(function () {
    rejectSnackbar();
  }, [rejectSnackbar]);

  var getSnackbarSeverity = function getSnackbarSeverity() {
    switch (snackbarId) {
      case Snackbars.Success:
        {
          return 'success';
        }

      case Snackbars.Error:
        {
          return 'error';
        }

      case Snackbars.Info:
        {
          return 'info';
        }

      default:
        {
          return 'success';
        }
    }
  };

  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(StyledSnackbar, {
      open: snackBar && snackBar.isOpen ? snackBar.isOpen : false,
      autoHideDuration: snackBar !== null && snackBar !== void 0 && (_snackBar$data = snackBar.data) !== null && _snackBar$data !== void 0 && _snackBar$data.disableAutoHide ? null : 3000,
      onClose: handleClose,
      anchorOrigin: {
        vertical: (snackBar === null || snackBar === void 0 ? void 0 : (_snackBar$data2 = snackBar.data) === null || _snackBar$data2 === void 0 ? void 0 : _snackBar$data2.vertical) || 'top',
        horizontal: (snackBar === null || snackBar === void 0 ? void 0 : (_snackBar$data3 = snackBar.data) === null || _snackBar$data3 === void 0 ? void 0 : _snackBar$data3.horizontal) || 'left'
      },
      ClickAwayListenerProps: {
        onClickAway: function onClickAway() {// empty
        }
      },
      children: /*#__PURE__*/_jsx(SnackbarAlert, {
        severity: getSnackbarSeverity(),
        sx: {
          width: '100%'
        },
        iconMapping: {
          success: /*#__PURE__*/_jsx(Icon, {
            src: SuccessIcon,
            width: 24,
            height: 24
          }),
          error: /*#__PURE__*/_jsx(Icon, {
            src: ErrorIcon,
            width: 24,
            height: 24
          }),
          info: /*#__PURE__*/_jsx(Icon, {
            src: InfoIcon,
            width: 24,
            height: 24
          })
        },
        children: (snackBar === null || snackBar === void 0 ? void 0 : (_snackBar$data4 = snackBar.data) === null || _snackBar$data4 === void 0 ? void 0 : _snackBar$data4.title) || ''
      })
    })
  });
};

export { SnackbarComponent };